import { ref, nextTick, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-14fc4f59"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainpage"
};
const _hoisted_2 = {
  class: "card"
};
const _hoisted_3 = {
  key: 0,
  class: "back-box",
  style: {
    "margin-bottom": "12px"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 小米商品配置 ")], -1));
const _hoisted_5 = {
  class: "optionLabel"
};
const _hoisted_6 = {
  class: "optionDescribtion"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "内购ID自动生成规则：包名+内购名称，大小写，不超过50字符", -1));
const _hoisted_8 = {
  key: 0,
  class: "card planCard"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 基础方案 ")], -1));
const _hoisted_10 = {
  class: "card priceCard"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 价格设置 ")], -1));
const _hoisted_12 = {
  key: 1,
  class: "card",
  style: {
    "padding": "0"
  }
};
const _hoisted_13 = {
  class: "submitBlock"
};
const _hoisted_14 = {
  class: "selectBox"
};
import useGetSelect from '@/hooks/useGetSelect';
import MultiComponents from './components/MultiComponents.vue';
import PriceBlock from './components/PriceBlock.vue';
import BasicPlanNotAuto from './components/BasicPlanNotAuto.vue';
import BasicPlanAuto from './components/BasicPlanAuto.vue';
import DiscountPlan from './components/DiscountPlan.vue';
import useDetailHooks from './hooks/useDetailHooks';
import useManualProdId from './hooks/useManualProdId';
import RecordDrawer from './components/RecordDrawer.vue';
import { cloneDeep } from 'lodash';
import { queryPkgInfo, queryGoods, addGoods, updGoods } from '@/api/goodsSetting';
import { useRoute, useRouter } from 'vue-router';
import { QuestionCircleOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { getNode, reportEvent } from '@/common';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'xiaomiDetail'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const {
      countryToCoin,
      getCountryCoinOptions
    } = useGetSelect('xiaomi');
    const {
      huaweiProdTypeOptions,
      detailFormInit,
      verifyNumber,
      validateXVOTPid
    } = useDetailHooks();
    const typeDisabled = ref(true);
    const disabled = ref(false); // 禁用改动
    let timout = null;
    const queryParams = ref({
      prodChnl: '',
      dbtId: '',
      id: null // 商品主键
    });
    const saveNext = ref(false); // 是否连续创建，保存后留在本页，清空配置信息，保留其他例如价格信息
    const multiComponentRef = ref(null); // 组件ref
    const priceBlockRef = ref(null);
    const myFormRef = ref(null);
    const discountPlanRef = ref(null);
    const loading = ref(false);
    const priceLoading = ref(false);
    const saveLoading = ref(false); // 保存按钮可用性
    const settingForm = ref(cloneDeep(detailFormInit));
    const {
      isManualProdId,
      handleProdIdFocus,
      handleProdIdBlur,
      resetManualProdId
    } = useManualProdId(() => settingForm.value.prodId);
    const validatePrice = [{
      placeholder: '商品名称, 最多50字符',
      maxLength: 50
    }, {
      placeholder: '商品描述, 最多100字符',
      maxLength: 100
    }];
    const recordVisible = ref(false);
    const getDetail = async () => {
      const res = await queryGoods({
        id: queryParams.value.id
      });
      if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
        var _priceBlockRef$value;
        settingForm.value = {
          ...res.data
        };
        (_priceBlockRef$value = priceBlockRef.value) === null || _priceBlockRef$value === void 0 || _priceBlockRef$value.init(res.data);
      }
    }; // 查询详情信息
    const getPkg = async () => {
      loading.value = true;
      const res = await queryPkgInfo({
        dbtId: queryParams.value.dbtId,
        prodChnl: queryParams.value.prodChnl
      });
      typeDisabled.value = false;
      if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
        settingForm.value.pkg = res.data.pkg;
        settingForm.value.prodId = res.data.pkg;
        settingForm.value.defaultLang = res.data.defaultLang;
        settingForm.value.prodPriceCurrency = countryToCoin.value[res.data.country];
      }
      loading.value = false;
    }; //查询包名等信息
    const getChangePrice = async () => {
      var _priceBlockRef$value2;
      if (timout) {
        clearTimeout(timout);
      }
      if (!settingForm.value.prodPrice) {
        message.warning('请先填写默认价格');
        return;
      }
      if (parseFloat(settingForm.value.prodPrice) <= 0) {
        settingForm.value.prodPrice = '';
        return;
      }
      const flag = await verifyNumber({
        prodChnl: queryParams.value.prodChnl,
        prodPrice: settingForm.value.prodPrice,
        prodPriceCurrency: settingForm.value.prodPriceCurrency,
        prodType: settingForm.value.prodType
      });
      if (!flag) {
        settingForm.value.prodPrice = '';
        return;
      }
      priceLoading.value = true;
      await ((_priceBlockRef$value2 = priceBlockRef.value) === null || _priceBlockRef$value2 === void 0 ? void 0 : _priceBlockRef$value2.queryData({
        pkg: settingForm.value.pkg,
        prodChnl: queryParams.value.prodChnl,
        prodPrice: parseFloat(settingForm.value.prodPrice).toFixed(2),
        prodPriceCurrency: settingForm.value.prodPriceCurrency,
        prodType: settingForm.value.prodType
      })); // 价格列表初始化
      priceLoading.value = false;
      callbackPrice();
    };
    const changeProdPrice = () => {
      // 节流
      if (timout) {
        clearTimeout(timout);
      }
      timout = setTimeout(async () => {
        getChangePrice();
      }, 800);
    }; // 变更默认价格需要重新请求价目表
    const callbackPrice = () => {
      var _priceBlockRef$value3;
      settingForm.value.prodPrice = (_priceBlockRef$value3 = priceBlockRef.value) === null || _priceBlockRef$value3 === void 0 || (_priceBlockRef$value3 = _priceBlockRef$value3.originData.filter(item => {
        return item.regionName === (settingForm.value.prodPriceCurrency === 'CNY' ? '中国' : '美国');
      })) === null || _priceBlockRef$value3 === void 0 || (_priceBlockRef$value3 = _priceBlockRef$value3[0]) === null || _priceBlockRef$value3 === void 0 ? void 0 : _priceBlockRef$value3.prodPrice;
    }; // 价格列表回调
    const cancel = () => {
      window.history.go(-1);
    }; // 取消逻辑
    const setProdId = e => {
      e = e.trim();
      if (queryParams.value.id) return; // 编辑时不允许修改内购ID
      if (isManualProdId.value) return; // 用户主动修改过，后面就不自动根据商品信息拼接
      let pkgStr = settingForm.value.pkg; // 拼接前缀
      let lengthLimit = 140; // 最大字符数
      if (['31', '32'].includes(settingForm.value.prodType)) {
        // 订阅非订阅类需要调整字符数和拼接pkg的内容
        pkgStr = settingForm.value.pkg.split('.').map(item => item[0]).join('.');
        lengthLimit = 40;
      }
      if (!e.length) {
        // 值为空的时候赋值为包名
        settingForm.value.prodId = pkgStr;
        return;
      }
      try {
        var _getStr$match;
        let getStr = e.toLowerCase().replace(/\s*/g, '');
        getStr = ((_getStr$match = getStr.match(/[a-z0-9\.]/g)) === null || _getStr$match === void 0 ? void 0 : _getStr$match.join('')) || '';
        let countStr = lengthLimit - pkgStr.length - 1;
        settingForm.value.prodId = pkgStr + '.' + getStr.slice(0, countStr);
      } catch (error) {}
      myFormRef.value.validate();
    }; // 根据商品名/订阅名，内购ID自动拼接
    const changeProdType = () => {
      nextTick(() => {
        var _settingForm$value;
        setProdId((_settingForm$value = settingForm.value) === null || _settingForm$value === void 0 || (_settingForm$value = _settingForm$value.productNativeInfo[0]) === null || _settingForm$value === void 0 ? void 0 : _settingForm$value.prodName);
      });
    }; // 变更商品类型需要注意内购ID重新组合
    const checker = () => {
      var _priceBlockRef$value4;
      for (let i = 0; i < settingForm.value.productNativeInfo.length; i++) {
        var _item$prodName, _item$prodDescription, _item$prodName2, _item$prodDescription2;
        let item = settingForm.value.productNativeInfo[i];
        if (!item.lang || !item.prodDescription || !item.prodName) {
          message.error('商品信息的语言，商品名称，商品描述需要正确填写完整');
          return false;
        }
        if (((_item$prodName = item.prodName) === null || _item$prodName === void 0 ? void 0 : _item$prodName.length) > 50) {
          item.error = '商品名称不能超过50个字符';
        }
        if (((_item$prodDescription = item.prodDescription) === null || _item$prodDescription === void 0 ? void 0 : _item$prodDescription.length) > 100) {
          item.error = '商品描述不能超过100个字符';
        }
        if (((_item$prodName2 = item.prodName) === null || _item$prodName2 === void 0 ? void 0 : _item$prodName2.length) <= 50 && ((_item$prodDescription2 = item.prodDescription) === null || _item$prodDescription2 === void 0 ? void 0 : _item$prodDescription2.length) <= 100) {
          item.error = '';
        }
      } // 商品信息校验
      if (settingForm.value.productNativeInfo.filter(item => item.error).length) {
        return false;
      }
      let getPriceArr = (_priceBlockRef$value4 = priceBlockRef.value) === null || _priceBlockRef$value4 === void 0 ? void 0 : _priceBlockRef$value4.originData;
      if (!getPriceArr.length) {
        message.error('价格信息表内容不能为空');
        return false;
      } else {
        for (let i = 0; i < getPriceArr.length; i++) {
          let item = getPriceArr[i];
          if (!item.prodPrice) {
            message.error('价格信息内容请填写完整');
            return false;
          }
        } // 价格信息校验
      }
      return true;
    }; // 自定义部分校验
    const handleSaveParams = () => {
      if (settingForm.value.prodType === '31') {
        var _settingForm$value2, _settingForm$value3, _settingForm$value4;
        delete settingForm.value.prodGracePlan;
        settingForm.value.prodBasePlan = {
          planDuration: (_settingForm$value2 = settingForm.value) === null || _settingForm$value2 === void 0 || (_settingForm$value2 = _settingForm$value2.prodBasePlan) === null || _settingForm$value2 === void 0 ? void 0 : _settingForm$value2.planDuration,
          timeExtension: (_settingForm$value3 = settingForm.value) === null || _settingForm$value3 === void 0 || (_settingForm$value3 = _settingForm$value3.prodBasePlan) === null || _settingForm$value3 === void 0 ? void 0 : _settingForm$value3.timeExtension,
          id: (_settingForm$value4 = settingForm.value) === null || _settingForm$value4 === void 0 || (_settingForm$value4 = _settingForm$value4.prodBasePlan) === null || _settingForm$value4 === void 0 ? void 0 : _settingForm$value4.id
        };
      } else if (settingForm.value.prodType === '32') {
        var _settingForm$value5, _settingForm$value6;
        (_settingForm$value5 = settingForm.value) === null || _settingForm$value5 === void 0 || (_settingForm$value5 = _settingForm$value5.prodBasePlan) === null || _settingForm$value5 === void 0 || delete _settingForm$value5.planDuration;
        (_settingForm$value6 = settingForm.value) === null || _settingForm$value6 === void 0 || (_settingForm$value6 = _settingForm$value6.prodBasePlan) === null || _settingForm$value6 === void 0 || delete _settingForm$value6.timeExtension;
      } else {
        delete settingForm.value.prodBasePlan;
        delete settingForm.value.prodGracePlan;
      }
    }; // 提交前根据商品类型处理多余结构
    const save = async () => {
      myFormRef.value.validate().then(async valid => {
        try {
          if (valid) {
            var _priceBlockRef$value5;
            if (!checker()) return;
            let fn = queryParams.value.id ? updGoods : addGoods;
            handleSaveParams();
            let params = {
              ...settingForm.value,
              prodChnl: queryParams.value.prodChnl,
              dbtId: queryParams.value.dbtId,
              productNativePrice: (_priceBlockRef$value5 = priceBlockRef.value) === null || _priceBlockRef$value5 === void 0 ? void 0 : _priceBlockRef$value5.originData
            };
            if (settingForm.value.prodType === '32' && discountPlanRef.value.checkOut()) {
              var _discountPlanRef$valu, _discountPlanRef$valu2, _settingForm$value7;
              params = {
                ...params,
                prodGracePlan: (_discountPlanRef$valu = discountPlanRef.value) !== null && _discountPlanRef$valu !== void 0 && _discountPlanRef$valu.handleData() ? {
                  ...((_discountPlanRef$valu2 = discountPlanRef.value) === null || _discountPlanRef$valu2 === void 0 ? void 0 : _discountPlanRef$valu2.handleData()),
                  id: (_settingForm$value7 = settingForm.value) === null || _settingForm$value7 === void 0 || (_settingForm$value7 = _settingForm$value7.prodGracePlan) === null || _settingForm$value7 === void 0 ? void 0 : _settingForm$value7.id
                } : null
              };
            } else if (settingForm.value.prodType === '32' && !discountPlanRef.value.checkOut()) {
              return params.prodGracePlan = null;
            }
            if (params.pkg === params.prodId) {
              return message.error('内购ID不可完全等于包名，请手动补齐内购ID后半部分');
            }
            saveLoading.value = true;
            const res = await fn(params);
            saveLoading.value = false;
            if (res.code === '0') {
              message.success('商品保存成功！');
              if (!saveNext.value) {
                router.push({
                  name: 'goodsSetting'
                });
              } else {
                var _priceBlockRef$value6;
                settingForm.value = {
                  ...cloneDeep(detailFormInit),
                  prodPriceCurrency: settingForm.value.prodPriceCurrency,
                  prodType: settingForm.value.prodType,
                  pkg: settingForm.value.pkg,
                  productNativeInfo: settingForm.value.productNativeInfo.map(item => {
                    return {
                      ...item,
                      prodDescription: '',
                      prodName: ''
                    };
                  })
                };
                (_priceBlockRef$value6 = priceBlockRef.value) === null || _priceBlockRef$value6 === void 0 || _priceBlockRef$value6.reset();
                resetManualProdId();
                changeProdType();
              }
              reportEvent({
                eventName: 'element_use',
                properties: {
                  ui_name: '小米商品配置',
                  element_name: '保存'
                }
              });
            } else {}
          }
        } catch (error) {}
      });
    }; // 保存逻辑
    onMounted(async () => {
      queryParams.value = {
        ...route.query
      };
      if (route.query.type === 'watch') {
        disabled.value = true;
      }
      await getCountryCoinOptions();
      await getPkg();
      if (queryParams.value.id) {
        getDetail();
      }
      settingForm.value.prodType = '20';
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_skeleton_button = _resolveComponent("a-skeleton-button");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        ref_key: "myFormRef",
        ref: myFormRef,
        model: settingForm.value,
        "label-col": {
          style: 'width: 90px'
        },
        autocomplete: "off"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [queryParams.value.id ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = () => {
            _unref(router).back();
          })
        }, {
          default: _withCtx(() => [_createTextVNode(" 返回 ")]),
          _: 1
        }), _createElementVNode("div", {
          class: "record-text",
          onClick: _cache[1] || (_cache[1] = $event => recordVisible.value = true)
        }, "变更记录")])) : _createCommentVNode("", true), _hoisted_4, _createVNode(_component_a_form_item, {
          label: "商品类型",
          name: "prodType",
          rules: [{
            required: true,
            type: 'string'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            class: "inputer",
            value: settingForm.value.prodType,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => settingForm.value.prodType = $event),
            options: _unref(huaweiProdTypeOptions),
            onChange: changeProdType,
            getPopupContainer: _unref(getNode),
            disabled: typeDisabled.value || disabled.value
          }, {
            option: _withCtx(({
              label,
              describtion
            }) => [_createElementVNode("div", _hoisted_5, _toDisplayString(label), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(describtion), 1)]),
            _: 1
          }, 8, ["value", "options", "getPopupContainer", "disabled"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "备注"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            class: "bigInputer",
            value: settingForm.value.remark,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => settingForm.value.remark = $event),
            placeholder: "请输入",
            disabled: disabled.value,
            maxLength: 20
          }, null, 8, ["value", "disabled"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "商品信息",
          rules: [{
            required: true
          }]
        }, {
          default: _withCtx(() => [loading.value ? (_openBlock(), _createBlock(_component_a_skeleton_button, {
            key: 0,
            active: "",
            block: "",
            style: {
              "width": "740px"
            }
          })) : (_openBlock(), _createBlock(MultiComponents, {
            key: 1,
            ref_key: "multiComponentRef",
            ref: multiComponentRef,
            filterItems: settingForm.value.productNativeInfo,
            onSetProdId: setProdId,
            disabled: disabled.value,
            "default-lang": settingForm.value.defaultLang,
            nameRule: validatePrice[0],
            desRule: validatePrice[1],
            channel: queryParams.value.prodChnl
          }, null, 8, ["filterItems", "disabled", "default-lang", "nameRule", "desRule", "channel"]))]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "内购ID",
          name: "prodId",
          rules: [{
            required: true,
            trigger: ['change', 'blur'],
            validator: _unref(validateXVOTPid)
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            class: "inputer",
            value: settingForm.value.prodId,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => settingForm.value.prodId = $event),
            placeholder: "请输入内购ID",
            disabled: Boolean(queryParams.value.id) || disabled.value,
            onFocus: _unref(handleProdIdFocus),
            onBlur: _unref(handleProdIdBlur)
          }, null, 8, ["value", "disabled", "onFocus", "onBlur"]), _createVNode(_component_a_tooltip, {
            placement: "right"
          }, {
            title: _withCtx(() => [_hoisted_7]),
            default: _withCtx(() => [_createVNode(_unref(QuestionCircleOutlined), {
              class: "infoIcon ml8"
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["rules"])]), ['31', '32'].includes(settingForm.value.prodType) ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, settingForm.value.prodType === '31' ? (_openBlock(), _createBlock(BasicPlanNotAuto, {
          key: 0,
          detail: settingForm.value,
          disabled: disabled.value
        }, null, 8, ["detail", "disabled"])) : _createCommentVNode("", true), settingForm.value.prodType === '32' ? (_openBlock(), _createBlock(BasicPlanAuto, {
          key: 1,
          detail: settingForm.value,
          disabled: disabled.value
        }, null, 8, ["detail", "disabled"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_a_form_item, {
          label: "默认价格",
          name: "prodPrice",
          rules: [{
            required: true
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input_number, {
            class: "priceInputer",
            value: settingForm.value.prodPrice,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => settingForm.value.prodPrice = $event),
            "addon-after": settingForm.value.prodPriceCurrency,
            step: 0.01,
            controls: false,
            precision: 2,
            "string-mode": "",
            disabled: disabled.value,
            onBlur: getChangePrice
          }, null, 8, ["value", "addon-after", "step", "disabled"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "本地价格",
          rules: [{
            required: true
          }],
          style: {
            "display": "none"
          }
        }, {
          default: _withCtx(() => [_createVNode(PriceBlock, {
            "prod-chnl": queryParams.value.prodChnl,
            "prod-price-currency": settingForm.value.prodPriceCurrency,
            "prod-type": settingForm.value.prodType,
            disabled: disabled.value,
            ref_key: "priceBlockRef",
            ref: priceBlockRef,
            onUpdateList: changeProdPrice,
            loading: priceLoading.value
          }, null, 8, ["prod-chnl", "prod-price-currency", "prod-type", "disabled", "loading"])]),
          _: 1
        })]), settingForm.value.prodType === '32' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(DiscountPlan, {
          ref_key: "discountPlanRef",
          ref: discountPlanRef,
          detail: settingForm.value,
          priceArr: priceBlockRef.value.originData,
          "read-only": disabled.value
        }, null, 8, ["detail", "priceArr", "read-only"])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model"]), _withDirectives(_createElementVNode("div", _hoisted_13, [_createVNode(_component_a_button, {
        onClick: cancel
      }, {
        default: _withCtx(() => [_createTextVNode("取 消")]),
        _: 1
      }), _createVNode(_component_a_button, {
        loading: saveLoading.value,
        class: "ml8",
        type: "primary",
        onClick: save,
        disabled: priceLoading.value
      }, {
        default: _withCtx(() => [_createTextVNode(" 保 存 ")]),
        _: 1
      }, 8, ["loading", "disabled"]), _withDirectives(_createElementVNode("div", _hoisted_14, [_createVNode(_component_a_checkbox, {
        checked: saveNext.value,
        "onUpdate:checked": _cache[6] || (_cache[6] = $event => saveNext.value = $event)
      }, {
        default: _withCtx(() => [_createTextVNode("连续创建")]),
        _: 1
      }, 8, ["checked"])], 512), [[_vShow, !queryParams.value.id]])], 512), [[_vShow, !disabled.value]]), _createVNode(RecordDrawer, {
        visible: recordVisible.value,
        "onUpdate:visible": _cache[7] || (_cache[7] = $event => recordVisible.value = $event)
      }, null, 8, ["visible"])]);
    };
  }
});